/** Shared bond list helpers (Law Firm pages + Bond Archives) to avoid duplicated maps and sort logic. */

export const BOND_TYPE_TO_SUBCATEGORIES = {
  Probate: [
    "Administrator",
    "Conservator",
    "Curator",
    "Executor",
    "Personal Representative",
  ],
  Guardianship: [
    "Guardian - Incapacitated",
    "Guardian - Minor",
    "Guardian - Advocate",
    "Conservator",
  ],
  Blanket: ["1 Year Bond", "2 Year Bond", "3 Year Bond"],
};

/**
 * @param {Array<object>} rows
 * @param {string} orderBy
 * @param {"asc"|"desc"} order
 */
export function sortBondRows(rows, orderBy, order) {
  return [...rows].sort((a, b) => {
    if (orderBy === "bond_amount") {
      const valA = Number.parseFloat(a.bond_amount);
      const valB = Number.parseFloat(b.bond_amount);
      return order === "asc" ? valA - valB : valB - valA;
    }
    if (orderBy === "created_at") {
      return order === "asc"
        ? new Date(a.created_at) - new Date(b.created_at)
        : new Date(b.created_at) - new Date(a.created_at);
    }
    const valA = a[orderBy]?.toString().toLowerCase() || "";
    const valB = b[orderBy]?.toString().toLowerCase() || "";
    return order === "asc"
      ? valA.localeCompare(valB)
      : valB.localeCompare(valA);
  });
}
